import React, {Component} from 'react';
import {connect} from "react-redux";
import {setInfoNoticeWasShown} from "../../redux/actions";

import styled, {css} from "styled-components";

import {animate, timeout} from "../../helpers/common";

import {ReactComponent as CircleIcon} from '../../assets/img/red-circle-icon.svg'

const Wrapper = styled.div`
  
  position: relative;
  width: 182px;
  background: #1A4362;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  pointer-events: none;
    
  ${props => props.visible && css`
      opacity: 1;
      transition: opacity 0.5s;
  `}
  
  ${props => !props.visible && css`
    opacity:0;
    transition: opacity 0.5s;
  `}
    
  &:after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0; 
    height: 0; 
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #1A4362;
  }
  
`;

const Text = styled.div`
  padding: 10px;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
`;

const ProgressBar = styled.div`

  height: 7px;
  background: rgba(255, 255, 255, 0.255655);

  span {
    display: block;
    height: 100%;
    width: 30px;
    background: #0080E2;
  }
  
`;

const StyledCircleIcon = styled(CircleIcon)`
  position: absolute;
  width: 45px;
  height: 45px;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
`;

class InfoNotice extends Component {

  state = {
    progress: 0,
    visible: false
  };

  async componentDidMount() {

    const {infoNoticeWasShown, setInfoNoticeWasShown} = this.props;

    if (infoNoticeWasShown) {
      return;
    }

    await timeout(800);

    this.setState({
      visible: true
    });

    animate({
      draw: progress => {
        this.setState({
          progress: Math.abs(Math.round(progress * 100))
        });
      },
      complete: () => {
        this.setState({
          visible: false
        });
        setInfoNoticeWasShown();
      },
      duration: 5000
    });

  }

  render() {

    const {className} = this.props,
      {progress, visible} = this.state;

    return (
      <Wrapper className={className} visible={visible}>
        <StyledCircleIcon/>
        <Text>
          Hier findest du weitere Infos zur Tischplatte.
        </Text>
        <ProgressBar>
          <span style={{width: `${progress}%`}}/>
        </ProgressBar>
      </Wrapper>
    );

  }
}


export default connect(
  state => ({
    infoNoticeWasShown: state.infoNoticeWasShown
  }),
  dispatch => ({
    setInfoNoticeWasShown: () => dispatch(setInfoNoticeWasShown())
  })
)(InfoNotice);
